module.exports = __webpack_public_path__ + "poster14.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster14.png
// module id = 1144
// module chunks = 10